// extracted by mini-css-extract-plugin
export default {"zoomModal":"z1-z","image":"A1-z","button":"B1-z","isOverlayShown":"C1-z"};